import { render, staticRenderFns } from "./Setmeal.vue?vue&type=template&id=20996b7b&scoped=true"
import script from "./Setmeal.vue?vue&type=script&lang=js"
export * from "./Setmeal.vue?vue&type=script&lang=js"
import style0 from "./Setmeal.vue?vue&type=style&index=0&id=20996b7b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20996b7b",
  null
  
)

export default component.exports